var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"outlined":"","loading":_vm.loading}},[_c('v-card-title',{staticClass:"justify-space-between"},[_c('h6',{staticClass:"mb-0"},[_vm._v("Mesas")]),_c('h5',{staticClass:"mb-0"},[_vm._v("1 ingresso")])]),_c('v-card-text')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }